/**
 * Annuleren van een deels met een cadeaubon betaalde bestelling geeft twee terugbetalingen: het
 * Mollie-deel en het bondeel. Dat tweede ging niet naar de bank maar terug op de bon; de server
 * markeert het met deze reden (`Terug op de cadeaubon: …`). Gedeeld door beheer en demo-server.
 */
export const VOUCHER_REFUND_PREFIX = 'Terug op de cadeaubon'

export const isVoucherRefund = (r: { reason: string }) => r.reason.startsWith(VOUCHER_REFUND_PREFIX)
